import { ZodSchema } from "zod";

/**
 * Validates input against the provided Zod schema.
 * Throws an error if validation fails.
 * @param schema - Zod schema to validate against
 * @param input - Input data to validate
 * @returns The validated data
 */
export function validateWithSchema<T>(schema: ZodSchema<T>, input: unknown): T {
  return schema.parse(input);
}
